import { useEffect } from "react";
import { _createProcess } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";

interface Props {
    idProcess: number,
    isOpen: boolean;
}
export const PaymentHeaderError = ({ idProcess, isOpen }: Props) => {

    const process = useDataBean(_createProcess);
    const { lista, setLista, bean, setBean } = process;

    useEffect(() => {
        if (idProcess && isOpen) {
            validateErrosPaymentHeaderByIdProcess();
        }
    }, [idProcess])

    const validateErrosPaymentHeaderByIdProcess = () => {
        process.instance.validateErrosPaymentHeaderByIdProcess(idProcess).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDPaymentHeader', visible: true, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'Nit', visible: true , mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Names', visible: true },
        { title: 'Debito', property: 'DebtValue', visible: true,mask:MASK_MONEY },
        { title: 'Credito', property: 'CreditValue', visible: true,mask:MASK_MONEY },
        { title: 'Error Info', property: 'ErrorsInfo', visible: true }
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
                <BasicTable body={lista} head={head} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}